module.exports = __webpack_public_path__ + "img/time_square.eb96d81f.svg";